<template>
  <v-text-field
    ref="input"
    v-currency="options"
    v-bind="$attrs"
    :value="formattedValue"
    @change="onChange"
    @input="onInput"
    @keyup="$emit('keyup', $event)"
  />
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: null
      },
      options: {
        type: Object,
        default: () => ({
          currency: null,
          precision: { min: 0, max: 2 }
        })
      }
    },
    data() {
      return {
        formattedValue: null
      }
    },
    watch: {
      value(value) {
        this.setValue(value)
      }
    },
    mounted() {
      this.setValue(this.value)
    },
    methods: {
      setValue(value) {
        this.$ci.setValue(this.$refs.input, value)
      },
      onInput(value) {
        this.formattedValue = value
      },
      onChange(value) {
        let numericValue = this.$ci.getValue(this.$refs.input)

        if (numericValue !== parseFloat(this.value)) {
          this.$emit('change', numericValue)
          this.$emit('input', numericValue)
        }
        // this.formattedValue = value
      }
    }
  }
</script>
